import { createAction } from 'redux-act'
import queryString from 'query-string'
import { replace } from 'react-router-redux'

export const updateCellarLanguages = createAction('languages/updateCellarLanguages')
export const updateCellarLanguage = createAction('languages/updateCellarLanguage')
export const updateEventLanguages = createAction('languages/updateEventLanguages')
export const updateEventLanguage = createAction('languages/updateEventLanguage')
export const updateSelectLanguages = createAction('languages/updateSelectLanguages')

function replaceQueryLanguage(language, dispatch) {
  const query = queryString.parse(window.location.search)
  Object.assign(query, {
    lang: language,
  })

  const url = `${window.location.pathname}?${queryString.stringify(query)}`
  dispatch(replace(url))
}

export const updateCellarLanguagesAction = (languages) => (dispatch) => {
  dispatch(updateCellarLanguages(languages))
}

export const updateCellarLanguageAction = (language) => (dispatch) => {
  replaceQueryLanguage(language, dispatch)
  dispatch(updateCellarLanguage(language))
}

export const updateEventLanguagesAction = (languages) => (dispatch) => {
  dispatch(updateEventLanguages(languages))
}

export const updateEventLanguageAction = (language) => (dispatch) => {
  replaceQueryLanguage(language, dispatch)
  dispatch(updateEventLanguage(language))
}

export const updateSelectLanguagesAction = (languages) => (dispatch) => {
  dispatch(updateSelectLanguages(languages))
}
